import { isShareActionType } from '@/forwarding/constants/ShareActionType';
import { RecentDestination } from '@/forwarding/types/RecentDestination';

export function getRecentDestinationKey(destination: RecentDestination): StringOrNumber {
  return isShareActionType(destination) ? destination : destination.id;
}
